import { Pipe, PipeTransform } from '@angular/core';
import { deviceFiltering } from '../constants/device-filtering';

@Pipe({
  name: 'deviceFilter'
})
export class DeviceFilterPipe implements PipeTransform {

  transform<T extends { ownerId: string }>(data: T[], filter: deviceFiltering, organizationId: string): T[] {
    switch (filter) {
      case deviceFiltering.all:
        return data;
      case deviceFiltering.onlyMyPrinters:
        return data.filter(d => d.ownerId === organizationId);
      case deviceFiltering.sharedWithMe:
        return data.filter(d => d.ownerId !== organizationId);
      default:
        return data;
    }
  }

}
